<template>
  <HelpCenterWrapper>
    <template #content>
      <CategoryTitle :title="$t('help_center.scam')" />
      <Links>
        <div class="column">
          <LinkContainer :category_title="$t('help_center.bots')" :list="scam_bot" />
          <LinkContainer :category_title="$t('help_center.other')" :list="scam_other" />
        </div>
        <LinkContainer :category_title="$t('help_center.deposit')" :list="scam_deposit" />
      </Links>
    </template>
  </HelpCenterWrapper>
</template>

<script setup>
import HelpCenterWrapper from '@/view/help-center/HelpCenterWrapper.vue';
import CategoryTitle from '@/component/help-center/CategoryTitle.vue';
import Links from '@/component/help-center/Links.vue';
import LinkContainer from '@/component/help-center/LinkContainer.vue';
import { filterSubcategory, scam_questions } from '@/helper/faq.js';

const scam_bot = filterSubcategory(scam_questions, 'help_center.bots');
const scam_deposit = filterSubcategory(scam_questions, 'help_center.deposit');
const scam_other = filterSubcategory(scam_questions, 'help_center.other');
</script>
